import React from "react";
import CostTable from "./CostTable";
import AccountTrendChart from "./AccountTrendChart";
import { formatCurrency } from "../utils/format";

const AccountServicesPanel = ({
  title,
  costTableData,
  costTableLoading,
  overrideNoTag,
  trendData,
  trendServices,
  trendHasOther,
  trendOtherColor,
  trendLoading,
  granularity,
  onGranularityChange
}) => (
  <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
    <h3 className="text-sm font-semibold text-slate-700 uppercase tracking-wide mb-4">{title}</h3>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div>
        <div className="bg-brand-50 rounded-lg px-4 py-3 mb-4">
          <p className="text-xs font-semibold text-brand-dark uppercase tracking-wide">Total</p>
          <p className="text-2xl font-bold text-slate-900 mt-1">
            {formatCurrency(costTableData?.totalCost)}
          </p>
        </div>

        <CostTable data={costTableData} loading={costTableLoading} overrideNoTag={overrideNoTag} />
      </div>

      <div>
        <div className="flex items-center gap-2 mb-4">
          {[
            { value: "monthly", label: "Monthly" },
            { value: "weekly", label: "Weekly" }
          ].map(option => (
            <button
              key={option.value}
              onClick={() => onGranularityChange(option.value)}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                granularity === option.value
                  ? "bg-brand-dark text-white"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>

        {trendLoading ? (
          <p className="text-slate-400 text-sm py-10 text-center">Loading trend…</p>
        ) : (
          <AccountTrendChart
            data={trendData}
            services={trendServices}
            hasOther={trendHasOther}
            otherColor={trendOtherColor}
            height={300}
          />
        )}
      </div>
    </div>
  </div>
);

export default AccountServicesPanel;
